export default __webpack_public_path__ + "static/Corprate_HK_Internships_MB-e366236bdb22d84533cf2f89f1a4b1fd.jpg";